var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.1 27.4",
    style: {
      enableBackground: "new 0 0 255.1 27.4"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.4,0.1h6.2l6.7,27.3h-5.6L69.4,0.1z M60.5,0.1h6.1l6.7,27.3h-5.5L60.5,0.1z M64.5,27.3H55l2.5-24.7L64.5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9,0.1v4.7h-7.2v10.9h6.5v4.7h-6.5v2.3h7.2v4.7H85.5V0.1H97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,0.1h15.2v4.7h-5v22.6h-5.2V4.8h-5V0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,0.1c5.6,0,10.2,4.5,10.2,10.1c0,3.1-1.5,6-3.9,8l3.9,9.2h-5.2l-3.1-7.2c-0.7,0.1-1.3,0.2-2,0.2v7h-5.2V0.1H124.8z  M129.8,10.2c0-3-2.3-5.5-5.1-5.5v10.9C127.6,15.7,129.8,13.2,129.8,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.7,13.7c0,7.6-5.8,13.7-12.9,13.7c-7.1,0-12.9-6.2-12.9-13.7C137.8,6.5,143.3,0,150.8,0C157.9,0,163.7,6.2,163.7,13.7z  M150.8,22.7c4.3,0,7.8-4.1,7.8-9s-3.5-9-7.8-9c-4.8,0-7.8,4.7-7.8,9C143,18.7,146.5,22.7,150.8,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,0.1c5.6,0,10.1,4.5,10.1,10.1s-4.5,10.1-10.1,10.1l0,0v7h-5.1V0.1H172z M177.1,10.2c0-3-2.3-5.5-5.1-5.5v10.9 C174.8,15.7,177.1,13.2,177.1,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,13.7c0,7.6-5.8,13.7-12.9,13.7c-7.1,0-12.9-6.2-12.9-13.7c0-7.2,5.5-13.7,12.9-13.7C205.4,0,211.2,6.2,211.2,13.7z  M198.3,22.7c4.3,0,7.8-4.1,7.8-9s-3.5-9-7.8-9c-4.8,0-7.8,4.7-7.8,9C190.5,18.7,194,22.7,198.3,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.8,22.7v4.7h-7.1v-4.7H227.8z M219.5,0.1v27.3h-5.1V0.1H219.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.2,0.1v27.3H231V0.1H236.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2,27.3c-3.3,0-6.4-1.6-7.4-4.5l4.8-2.1c0,1.1,1.2,1.9,2.6,1.9s2.6-0.9,2.6-1.9c0-2.5-10.4-4.3-10.4-12.6 c0-4.7,3.8-8,8.5-8c3.9,0,7.1,3,7.1,6.6c0,3-2.2,5.6-5.1,6.3L248,8.6c1.1,0,2-0.8,2-1.9s-0.8-2-1.9-2H248c-1.8,0-3.3,1.5-3.3,3.3 l0,0c0,5.3,10.4,5.6,10.4,12.6C255,25,251.2,27.3,247.2,27.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,13.29V9.13L18.66,4.5v3.86L0,13.29z M0,19.3v-4.16l18.66-4.47v3.7L0,19.3z M18.66,16.68v6.48L1.7,21.46L18.66,16.68z  M38.71,13.29V9.13L20.2,4.5v3.86L38.71,13.29z M38.71,19.3v-4.16L20.2,10.67v3.7L38.71,19.3z M20.2,16.68v6.48l16.96-1.7 L20.2,16.68z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWide);
export default ForwardRef;